import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import { getViewReturnItems } from "../../../../../Store/prosafe/proTransaction/PurReturn/getViewReturnItems";
import { Pagination, Search } from "../../../Table";
import DropDown from "../../../../../Components/DropDown";

const ReadOnlyInput = ({ label, value }) => (
  <div className="col-12 col-md-4 col-xl-4">
    <div className="input-block local-forms custom-select-wpr">
      <label>{label}</label>
      <input className="form-control" value={value || "-"} readOnly />
    </div>
  </div>
);

const ViewPurReturn = () => {
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewReturnItems({ formData: { id: data?._id } }));
    }
  }, [data]);

  const itemData = useSelector(
    (state) => state?.getViewReturnItems?.user?.data
  );

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Return",
      link: "/main-store/user/purchase-return-management",
    },
    { label: "View Purchase Return", active: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = itemData?.items_details || [];
    if (search) {
      computedComments = computedComments.filter((fi) =>
        fi.item_name?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, itemData]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>View Purchase Return Details</h4>
                      </div>
                    </div>
                    <div className="row">
                      <ReadOnlyInput
                        label="Project No"
                        value={data?.manual_pro_no}
                      />
                      <ReadOnlyInput
                        label="Project"
                        value={`${data?.project_data?.name} ${data?.project_data?.project_no
                            ? `(${data?.project_data?.project_no} )`
                            : ""
                          } `}
                      />
                      <ReadOnlyInput
                        label="Party"
                        value={data?.party_data?.name}
                      />
                      <ReadOnlyInput
                        label="Voucher No"
                        value={data?.voucher_no}
                      />
                      <ReadOnlyInput label="Bill No" value={data?.bill_no} />
                      <ReadOnlyInput
                        label="Challan No"
                        value={data?.challan_no}
                      />
                      <ReadOnlyInput label="LR No" value={data?.lr_no} />
                      <ReadOnlyInput
                        label="Vehicle No"
                        value={data?.vehical_no}
                      />
                      <ReadOnlyInput
                        label="Driver Name"
                        value={data?.driver_name}
                      />
                      <ReadOnlyInput
                        label="Transport Charges (₹)"
                        value={data?.transport_charges}
                      />
                      <ReadOnlyInput
                        label="Transport Name"
                        value={data?.transport_data?.name}
                      />
                      <ReadOnlyInput
                        label="Item Count"
                        value={data?.item_count}
                      />
                      <ReadOnlyInput
                        label="Transaction Date"
                        value={data?.trans_date?.slice(0, 10)}
                      />
                      <ReadOnlyInput
                        label="Receive Date"
                        value={data?.receive_date?.slice(0, 10)}
                      />
                      <ReadOnlyInput
                        label="Transport Date"
                        value={data?.transport_date?.slice(0, 10)}
                      />
                      <ReadOnlyInput
                        label="LR Date"
                        value={data?.lr_date?.slice(0, 10)}
                      />
                      {data?.pdf && (
                        <div className="col-12 col-md-4 col-xl-4">
                          <div className="input-block local-forms custom-select-wpr">
                            <label>Document</label>
                            {/\.(pdf)$/i.test(data.pdf) ? (
                              <a
                                href={data.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary w-100 text-center mt-1"
                              >
                                View PDF
                              </a>
                            ) : (
                              <a
                                href={data.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={data.pdf}
                                  alt="Uploaded File"
                                  style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                    border: "1px solid #ccc",
                                    padding: "4px",
                                    borderRadius: "4px",
                                  }}
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="page-table-header mb-2 p-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Items List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }}
                                />
                                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                <a className="btn">
                                  <img
                                    src="/assets/img/icons/search-normal.svg"
                                    alt="search"
                                  />
                                </a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown
                          limit={limit}
                          onLimitChange={(val) => setlimit(val)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table mb-0">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Item No</th>
                          <th>Item Name</th>
                          <th>Item Length</th>
                          <th>Item Width</th>
                          <th>Item Weight</th>
                          <th>Item Radius</th>
                          <th>Item Thickness</th>
                          <th>Assembly Weight</th>
                          <th>Surface Area</th>
                          <th>Return Qty</th>
                          <th>Rate(₹)</th>
                          <th>Amount(₹)</th>
                          <th>Discount (%)</th>
                          <th>Discount Amount(₹)</th>
                          <th>Special Discount (%)</th>
                          <th>Special Discount Amount(₹)</th>
                          <th>Taxable Amount(₹)</th>
                          <th>GST (%)</th>
                          <th>GST Amount(₹)</th>
                          <th>Total Amount(₹)</th>
                          <th>Heat No</th>
                          <th>Plate No</th>
                          <th>TC No</th>
                          <th>Remarks</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commentsData?.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{index + 1}</td>
                            <td>{item.item_no || "-"}</td>
                            <td>{item.item_name || "-"}</td>
                            <td>{item.item_length || "-"}</td>
                            <td>{item.item_width || "-"}</td>
                            <td>{item.item_weight || "-"}</td>
                            <td>{item.item_radius || "-"}</td>
                            <td>{item.item_thickness || "-"}</td>
                            <td>{item.assembly_weight || "-"}</td>
                            <td>{item.assembly_surface_area || "-"}</td>
                            <td>{item.quantity ?? "-"}</td>
                            <td>
                              {item.rate ? Number(item.rate).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.amount
                                ? Number(item.amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.discount
                                ? Number(item.discount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.discount_amount
                                ? Number(item.discount_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.sp_discount
                                ? Number(item.sp_discount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.sp_discount_amount
                                ? Number(item.sp_discount_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.taxable_amount
                                ? Number(item.taxable_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.gst ? Number(item.gst).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.gst_amount
                                ? Number(item.gst_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.total_amount
                                ? Number(item.total_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>{item.heat_no || "-"}</td>
                            <td>{item.plat_no || "-"}</td>
                            <td>{item.tc_no || "-"}</td>
                            <td>{item.remarks || "-"}</td>
                            <td>{item.isAuto ? "Auto" : "Manual"}</td>
                          </tr>
                        ))}
                        {commentsData?.length === 0 ? (
                          <tr>
                            <td colSpan="999">
                              <div className="no-table-data">
                                No Data Found!
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                        data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={() =>
                          navigate(
                            "/main-store/user/purchase-return-management"
                          )
                        }
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPurReturn;
